import Swiper, { Navigation } from "swiper";
Swiper.use([Navigation])

class EventSlider {
  constructor (el) {
    this.el = el
    this.slider = null
    this.container = this.el.closest('.event-slider')
    this.prev = this.container.querySelector('.event-slider__btn--prev')
    this.next = this.container.querySelector('.event-slider__btn--next')
  }

  init () {
    if (this.slider) return

    this.slider = new Swiper(this.el, {
      slidesPerView: 1,
      spaceBetween: 16,
      observer: true,
      observeParents: true,
      watchOverflow: true,
      navigation: {
        prevEl: this.prev,
        nextEl: this.next
      },
      breakpoints: {
        768: {
          spaceBetween: 48
        },
        1025: {
          spaceBetween: 72
        }
      }
    })
  }

  destroy () {
    if (!this.slider) return
    this.slider.destroy()
    this.slider = null
  }
}

window.addEventListener("DOMContentLoaded", () => {
  const items = document.querySelectorAll(".js-event-slider");
  const eventSliders = []
  if (items.length) {
    items.forEach((el, i) => {
      eventSliders[i] = new EventSlider(el)
      eventSliders[i].init()
    })
  }
});